import { Link } from "react-router-dom";
import styled from "styled-components";

export const DashboardWrap = styled.div`
	min-height: calc(100vh - 92px);
	background-color: #f3f4f6;
`;

export const DashboardShell = styled.div`
	width: 1200px;
	max-width: 1440px;
	margin: 0 auto;
	padding: 32px 0 40px;
`;

export const DashboardTitle = styled.h1`
	margin: 0 0 8px;
	font-size: 28px;
	line-height: 34px;
	color: #111827;
`;

export const DashboardSubtitle = styled.p`
	margin: 0 0 24px;
	color: #6b7280;
	font-size: 15px;
	line-height: 22px;
`;

export const DashboardSection = styled.section`
	&:not(:first-of-type) {
		margin-top: 32px;
	}
`;

export const DashboardSectionTitle = styled.h2`
	margin: 0 0 12px;
	font-size: 18px;
	font-weight: 600;
	line-height: 24px;
	color: #374151;
`;

export const DashboardGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 16px;
`;

export const DashboardCard = styled(Link)`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 18px;
	border-radius: 16px;
	background: #ffffff;
	box-shadow: 0px 4px 14.6px rgba(0, 0, 0, 0.08);
	text-decoration: none;
	color: #111827;
	transition: transform 0.15s ease, box-shadow 0.15s ease;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0px 8px 20px rgba(17, 24, 39, 0.12);
	}
`;

export const DashboardCardIcon = styled.i`
	font-size: 18px;
	color: #035d9d;
`;

export const DashboardCardTitle = styled.div`
	font-size: 17px;
	font-weight: 600;
	line-height: 22px;
`;

export const DashboardCardDescription = styled.div`
	font-size: 14px;
	line-height: 20px;
	color: #6b7280;
`;
